export const table = {
      code: 'Código',
      product: 'Producto',
      category: 'Categoría',
      unit: 'Unidad / Presentación',
      warehouse: 'Almacén',
      minimum: 'Mínimo',
      maximum: 'Máximo',
      cost: 'Costo',
      value: 'Valor',
      availableBoxes: 'Cajas disponibles',
      type: 'Tipo',
      quantity: 'Cantidad',
      stock: 'Existencias',
      date: 'Fecha',
      report: 'Reporte',
      description: 'Descripción',
    } as const;
